import React from 'react';

import Background from '../Background';

import SidebarAnimation from './Sidebar.animation';
import { Bottom, Content, Top, Wrapper } from './Sidebar.styles';
import { SidebarProps } from './types';

const Sidebar: React.FC<SidebarProps> = ({
  ContentComponent,
  onCloseClick,
  TopComponent,
  BottomComponent,
  isVisible,
}) => {
  return (
    <>
      <Background isVisible={isVisible} onCloseClick={onCloseClick} />
      <SidebarAnimation inProp={isVisible}>
        <Wrapper>
          <Top>{TopComponent}</Top>
          <Content>{ContentComponent}</Content>
          <Bottom>{BottomComponent}</Bottom>
        </Wrapper>
      </SidebarAnimation>
    </>
  );
};

export default Sidebar;
